import { useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"

import { CheckEmail } from "@/components/auth/check-email"
import { useAuth } from "@/hooks/use-auth"
import { navigateWithThreadPreservation } from "@/utils/thread-navigation"

export function CheckEmailPage() {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    if (isAuthenticated) {
      navigateWithThreadPreservation(navigate, "/profile", searchParams)
    }
  }, [isAuthenticated, navigate, searchParams])

  return (
    <main className="flex min-h-dvh w-full items-center justify-center bg-background px-4 py-10">
      <CheckEmail className="w-full max-w-md" />
    </main>
  )
}
